import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import CodiceVSVoceCliccabile2 from '../interfaccia/voci/CodiceVSVoceCliccabile2';
import umanizzaDataSenzaSecondi from '../interfaccia/funzioniComuni/umanizzaDataSenzaSecondi';
import stileGrid from '../interfaccia/stileGrid';

function UltimeModificheUtenteLista ({
  lista,
  setProductFunction,
  utente,
  misure
}) {

    const [rows,setRows] = useState(
        lista
      )
/* 
    const umanizzaData = function(dataDisumana) {
      const d = Date.parse(dataDisumana)
      const dt = new Date(d)  
      return `${
              dt.getDate().toString().padStart(2, '0')}/${(dt.getMonth()+1).toString().padStart(2, '0')}/${
              dt.getFullYear().toString().padStart(4, '0')} ${
              dt.getHours().toString().padStart(2, '0')}:${
              dt.getMinutes().toString().padStart(2, '0')}:${
              dt.getSeconds().toString().padStart(2, '0')}`;
    } */

              

    useEffect(() => {
        setRows(lista)
      },[lista]);

      const columns = [
        {
            field: 'codVS',
            headerName: 'VS',
            width: misure.vs,
            headerClassName: "b", // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
            renderCell: (params) => {
              /* return <div className="rowitem">{params.row.codiceVS}</div>; */
              if (params.row.codVS) { return <CodiceVSVoceCliccabile2 
                codVS={params.row.codVS}
                codPS="NULL"
                codProd="NULL"
                shortName={params.row.shortName}
                setProductFunction={setProductFunction} 
                utente={utente}
                tit='NULL'
                /> } else { return <div className="rowitem">N/A</div> }
            }
          },
          {
            field: 'shortName',
            valueGetter: (params) => params.row.shortName ?? "N/A",
            headerName: 'shortname',
            width: misure.shortname
          },
          {
            field: 'brand',
            valueGetter: (params) => params.row.brand ?? "N/A",
            headerName: 'brand',
            width: misure.brand
          },
          {
            field: 'data',
            valueGetter: (params) => params.row.data ?? "N/A",
            renderCell: (params) => {
              if (params.row.data) { return <div className="rowitem">{umanizzaDataSenzaSecondi(params.row.data)}</div>; } else { return <div className="rowitem">N/A</div> }
            },
            headerName: 'data',
            width: misure.data
          }/* ,  // PER IL MOMENTO GLI APPUNTI LI LASCIO PERDERE
          {
            field: 'appunti',
            valueGetter: (params) => params.row.appunti ?? "N/A",
            headerName: 'appunti',
            width: 200
          } */
      ];
    
      return (
        <div
      className="colonna50vh">
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row["objectId"]}
            autoPageSize
            rowsPerPageOptions={[10, 20, 50]}
            pagination
            sx={stileGrid}
          />
                           
        </div>
      )
}

export default UltimeModificheUtenteLista;